import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
} from "../../../components/card/card";
import ImageViewer from "../../../components/ImageViewer";
import {
  generateLocationToArray,
  Loader,
  printDate,
  printLocation,
} from "../../../utils/helper";
import React, { useState, useEffect } from "react";
import { user as userAPI, matar, machineProfile } from "../../../api";
import { parserAPI } from "../../../utils/parser";
import { useQuery } from "@tanstack/react-query";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import NormalInput from "../../../components/form/HorizontalNormalInput";

import ConfirmationDlg from "../../../components/ConfirmationDlg";
import Select, { StylesConfig } from "react-select";
import { LocationFilter } from "../../../components/LocationFilter";
import { useDashboardContext } from "../../../contexts/NewDashboardContext";

const colourStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "transparent",
    zIndex: 99,
  }),
  input: (styles) => ({
    ...styles,
    color: "white",
  }),
  menu: (styles) => ({
    ...styles,
    color: "grey",
  }),
};

function MatarGroup() {
  const machineTypes = [
    {
      id: "555b1dc5-6983-4501-afdf-474665a3e131",
      name: "Compressor",
    },
    {
      id: "ApronDrive",
      name: "Apron Drive",
    },
    {
      id: "Transformer",
      name: "Transformer",
    },
  ];
  const [search, setSearch] = useState("");
  const [query, setQuery] = useState({ company: true });
  const [page, setPage] = useState(1);
  const [openDetail, setOpenDetail] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const [confirmDlg, setConfirmDlg] = useState(false);
  const [openModalGroup, setOpenModalGroup] = useState(false);
  const [teamName, setGroupName] = useState("");
  const [member, setMember] = useState([]);
  const [users, setUsers] = useState([]);
  const [teams, setGroups] = useState([]);
  const [choosen, setChoosen] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [deleteRow, setDeleteRow] = useState(null);
  const [datas, setDatas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalPage, setTotalPage] = useState(1);

  const handleChangeLocationFilter = (location_id) => {
    setQuery((prev) => ({
      ...prev,
      location_id: location_id ? location_id : "",
    }));
  };

  const handleChangeMachineType = (machine_type_id) => {
    setQuery((prev) => ({
      ...prev,
      machine_type_id: machine_type_id,
    }));
  };
  async function getData(forcePage) {
    try {
      setLoading(true);
      const queryParam = {
        ...query,
        page: forcePage ? forcePage : page,
      };
      const res = await machineProfile.list(queryParam);
      if (res.ok) {
        const body = await res.json();
        let data = body.data?.results;
        const totalPage = body.data?.totalPage;
        setTotalPage(totalPage);
        if (data) {
          data.forEach((d) => {
            const locationNameArr = [];
            generateLocationToArray(d.location, locationNameArr);
            d.location_arr = locationNameArr.reverse();

            // check if available in choosen set status=1
            const found = choosen.find((i) => i.id === d.id);
            if (found) {
              d.status = 1;
            } else {
              d.status = 0;
            }
          });
          setDatas(data);
        }
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      toast.error(e.message);
      console.error(e);
    }
  }

  const addToChoosen = (i) => {
    const newChoosen = [...choosen, i];
    setChoosen(newChoosen);
    const newDatas = datas.map((d) => {
      if (d.id === i.id) {
        d.status = 1;
      }
      return d;
    });
    setDatas(newDatas);
  };

  const columnAssets = [
    {
      name: <div>Action</div>,
      selector: (row) => row["id"],
      style: { whiteSpace: "unset" },
      minWidth: "100px",
      cell: (row) => (
        <div>
          {row.status === 1 ? (
            <div>
              <i className="fa fa-check color-theme"></i>
            </div>
          ) : (
            <button
              onClick={() => {
                addToChoosen(row);
              }}
              className={"btn btn-sm btn-theme text-black"}
            >
              Add
            </button>
          )}
        </div>
      ),
      maxWidth: "100px",
    },
    {
      name: <div>Asset ID</div>,
      selector: (row) => row["id"],
      style: { whiteSpace: "unset" },
      minWidth: "200px",
      wrap: true,
      maxWidth: "200px",
    },
    {
      name: "Asset Name",
      selector: (row) => row["machine_name"],
      style: { whiteSpace: "unset" },
      minWidth: "300px",
      wrap: true,
      maxWidth: "300px",
    },
    {
      name: "Asset Category",
      selector: (row) => row["machine_model_no"],
      style: { whiteSpace: "unset" },
      wrap: true,
      minWidth: "200px",
      maxWidth: "200px",
    },
    {
      name: <div>Replacement Year Based on RUL</div>,
      selector: (row) => row["Forecasted Replacement Date"],
      minWidth: "170px",
      maxWidth: "170px",
      cell: (row) => row?.MachineStrategies[0]?.replacement_year,
    },
    {
      name: <div>CAPEX</div>,
      selector: (row) => row["maintenance"],
      minWidth: "150px",
      maxWidth: "150px",
      cell: (row) => row?.MachineStrategies[0]?.default_capex,
    },
  ];
  async function getGroup() {
    try {
      const res = await matar.getGroupMatar();
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        if (data.length) {
          setGroups(data);
          setIsDirty(false);
        } else {
          setGroups([]);
          setIsDirty(false);
        }
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }
  useEffect(() => {
    // wait for 1 second before calling getData
    const timer = setTimeout(() => {
      if (search) {
        const queryParam = {
          ...query,
          search: search.toUpperCase(),
        };
        setQuery(queryParam);
      } else {
        setQuery({ company: true });
      }
    }, 1000);
    return () => {
      clearTimeout(timer);
    };
  }, [search]);

  useEffect(() => {
    getGroup();
  }, []);

  useEffect(() => {
    getData();
  }, [page]);
  useEffect(() => {
    setPage(1);
    getData(1);
  }, [query]);

  function selectUser(value) {
    //console.log("selected machine", value);
  }
  function addUser(value) {
    setSelectedRow(null);
    setOpenModalGroup(true);
    setGroupName("");
    setMember([]);
    setChoosen([]);
    setStatus0();
  }
  function setStatus0() {
    const newData = [...datas];
    newData.forEach((d) => {
      d.status = 0;
    });
    setDatas(newData);
  }
  function checkChoosen(list) {
    const newData = [...datas];
    newData.forEach((d) => {
      const found = list.find((i) => i.id === d.id);
      if (found) {
        d.status = 1;
      } else {
        d.status = 0;
      }
    });
    setDatas(newData);
  }
  function editUser(value) {
    setSelectedRow(value);
    setOpenModalGroup(true);
    setGroupName(value.name);
    const newMember = value.MachineGroup.map((i) => {
      return {
        id: i.machine_id,
      };
    });
    setChoosen(newMember);
    checkChoosen(newMember);
  }

  function showConfirmationDlg(row) {
    setDeleteRow(row);
    setConfirmDlg(true);
  }
  function hideConfirmationDialog() {
    setDeleteRow(null);
    setConfirmDlg(false);
  }

  async function deleteUser() {
    try {
      const res = await matar.deleteGroup({ id: deleteRow.id });
      if (res.ok) {
        toast.success("This team has been deleted");
        setConfirmDlg(false);
        setDeleteRow(null);
        const body = await res.json();
        setIsDirty(true);
        await getGroup();
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }
  const columns = [
    {
      name: "Group Name",
      selector: (row) => row.name,
    },
    {
      name: "Total Asset",
      minWidth: "200px",
      style: {
        paddingRight: "0",
      },
      cell: (row) => {
        return <span>{row.MachineGroup?.length}</span>;
      },
    },
    {
      name: "Action",
      width: "150px",
      style: {
        paddingRight: "0",
      },
      cell: (row) => {
        return (
          <div>
            <button
              onClick={() => {
                editUser(row);
              }}
              className="btn btn-sm btn-outline-theme mx-1"
            >
              <i className="fa fa-edit"></i>
            </button>
            <button
              onClick={() => {
                showConfirmationDlg(row);
              }}
              className="btn btn-sm btn-outline-danger"
            >
              <i className="fa fa-trash"></i>
            </button>
          </div>
        );
      },
    },
  ];
  async function onSubmit({
    username,
    password,
    email,
    jobTitle,
    firstname,
    lastname,
    contactNumber,
    userRole,
    status,
  }) {
    let data = {
      username,
      password,
      email,
      job_title: jobTitle,
      firstname,
      lastname,
      //contact_number: contactNumber,
      role_id: userRole,
      //is_active: status == 1 ? true : false,
      is_staff: false,
    };
    if (!selectedRow) {
      const response = await userAPI.create(data);
      if (response.ok) {
        const body = await response.json();
        //console.log({ body });
        if (body.success) {
          //toast.success(body.message);
          toast.success("User " + username + " is successfully added");
          setSelectedRow(null);
          setOpenDetail(false);
          setIsDirty(true);
        } else {
          toast.error(body.message);
        }
      } else {
        toast.error("API Error");
      }
    } else {
      const response = await userAPI.update(selectedRow.username, data);
      if (response.ok) {
        const body = await response.json();
        //console.log({ body });
        if (body.success) {
          //toast.success(body.message);
          toast.success("User " + username + " is successfully updated");
          setSelectedRow(null);
          setOpenDetail(false);
          setIsDirty(true);
        } else {
          toast.error(body.message);
        }
      } else {
        toast.error("API Error");
      }
    }
  }

  const handlePageChange = (page) => {
    setPage(page);
  };

  async function onSubmitGroup() {
    if (choosen.length === 0) {
      toast.error("Please choose at least one Asset");
      return;
    }
    const arr = choosen.map((i) => {
      return i.id;
    });
    let data = {
      name: teamName,
      machine_id_list: arr,
    };

    if (!selectedRow) {
      const response = await matar.createGroup(data);
      if (response.ok) {
        const body = await response.json();
        //console.log({ body });
        if (body.success) {
          //toast.success(body.message);
          toast.success("Group " + teamName + " is successfully added");
          setSelectedRow(null);
          setOpenModalGroup(false);
          setIsDirty(true);
          await getGroup();
        } else {
          toast.error(body.message);
        }
      } else {
        toast.error("API Error");
      }
    } else {
      data.id = selectedRow.id;
      const response = await matar.updateGroup(data);
      if (response.ok) {
        const body = await response.json();
        //console.log({ body });
        if (body.success) {
          //toast.success(body.message);
          toast.success("Group " + teamName + " is successfully updated");
          setSelectedRow(null);
          setOpenModalGroup(false);
          setIsDirty(true);
          await getGroup();
        } else {
          toast.error(body.message);
        }
      } else {
        toast.error("API Error");
      }
    }
  }

  return (
    <div>
      <ConfirmationDlg
        size={"xl"}
        open={openModalGroup}
        onSubmit={onSubmitGroup}
        btnSubmitText={"Save"}
        title={"Add Group"}
        btnCancelText={"Cancel"}
        onClose={() => {
          setOpenModalGroup(false);
        }}
      >
        <NormalInput
          required={true}
          value={teamName}
          type={"text"}
          label="Group Name"
          onchange={(e) => {
            setGroupName(e.target.value);
          }}
          name="teamName"
        />
        <div className="row mb-2">
          <div className="col-sm-3 mb-2 mb-sm-0">
            <input
              style={{ padding: "5px", borderRadius: "4px" }}
              placeholder={"Search Asset..."}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="border border-theme w-100 bg-transparent text-theme"
            />
          </div>
          <div className="col-sm-3 mb-2 mb-sm-0">
            <LocationFilter onChange={handleChangeLocationFilter} />
          </div>
          <div className="col-sm-3 mb-2 mb-sm-0">
            <select
              className="form-select btn btn-sm btn-outline-theme"
              defaultValue=""
              onChange={(e) => {
                handleChangeMachineType(e.target.value);
              }}
            >
              <option value="">- Asset Category -</option>
              {machineTypes.map((mt) => (
                <option key={mt.id} value={mt.id}>
                  {mt.name}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-7">
            <Card className={"border-theme"}>
              <CardHeader>Choose Asset</CardHeader>
              <CardBody>
                <div
                  style={{
                    height: "400px",
                    overflow: "auto",
                  }}
                >
                  <Loader loading={loading}>
                    <DataTable
                      paginationPerPage={20}
                      paginationRowsPerPageOptions={[20]}
                      highlightOnHover
                      theme="dark"
                      columns={columnAssets}
                      data={datas}
                      pagination
                      paginationServer
                      paginationTotalRows={totalPage * 20}
                      onChangePage={handlePageChange}
                    />
                  </Loader>
                </div>
              </CardBody>
            </Card>
          </div>
          <div class="col-sm-5">
            <Card className={"border-primary"}>
              <CardHeader>Choosen Asset</CardHeader>
              <CardBody>
                <div
                  style={{
                    height: "400px",
                    overflow: "auto",
                  }}
                >
                  <table
                    className={"table table-bordered table-sm table-striped"}
                  >
                    <thead>
                      <tr>
                        <th>Action</th>
                        <th>Asset ID</th>
                      </tr>
                    </thead>
                    <tbody>
                      {choosen.map((i) => {
                        return (
                          <tr key={i.id}>
                            <td>
                              <button
                                onClick={() => {
                                  const newChoosen = choosen.filter(
                                    (j) => j.id !== i.id
                                  );
                                  setChoosen(newChoosen);
                                  const newDatas = datas.map((d) => {
                                    if (d.id === i.id) {
                                      d.status = 0;
                                    }
                                    return d;
                                  });
                                  setDatas(newDatas);
                                }}
                                className={"btn btn-sm btn-danger"}
                              >
                                Remove
                              </button>
                            </td>
                            <td>{i.id}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </CardBody>
            </Card>
          </div>
        </div>

        <div className="text-theme float-end">
          {choosen.length} Asset Selected
        </div>
      </ConfirmationDlg>
      <ConfirmationDlg
        open={confirmDlg}
        onClose={() => {
          setConfirmDlg(false);
          setDeleteRow(null);
        }}
        onSubmit={deleteUser}
      >
        <div>Are you sure you want to delete this Group?</div>
      </ConfirmationDlg>
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#/">Configuration</a>
            </li>
            <li className="breadcrumb-item active">Group</li>
          </ol>
          <h1 className="page-header mb-0">Group</h1>
        </div>
      </div>

      <div className="row gx-4">
        <div className="col-lg-12 ">
          <div className="row justify-content-end">
            <div className="col-sm-3 mb-2 mb-sm-0">
              <button onClick={addUser} className="btn btn-outline-theme w-100">
                Add Group <i className="bi bi-plus"></i>
              </button>
            </div>
          </div>
          <Card className="mb-4 mt-2">
            <CardHeader>List Asset Group</CardHeader>
            <CardBody>
              <DataTable
                pointerOnHover
                onRowClicked={(row) => {
                  editUser(row);
                }}
                highlightOnHover
                theme="dark"
                columns={columns}
                data={teams}
                pagination
              />
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
}
export default MatarGroup;
